// Bunny images are stored either as a plain URL string (legacy) or as
// { url, position } once an admin has set a focal point via the crop tool.
export const getImageUrl = (image) => (typeof image === 'string' ? image : image?.url) || '';

export const getImagePosition = (image) =>
  (typeof image === 'object' && image?.position) ? image.position : undefined;
